<template>
  <li class="market-item" @click="$emit('select', coin)">
    <div class="coin-main">
      <div class="coin-icon-wrapper">
        <img
          v-if="coin.image"
          :src="coin.image"
          :alt="coin.name"
          class="coin-icon"
        />
        <div v-else class="coin-icon-placeholder">
          {{ coin.symbol?.toUpperCase().slice(0, 2) }}
        </div>
      </div>
      <div class="coin-info">
        <div class="coin-name-row">
          <span class="coin-name">{{ coin.name }}</span>
          <span class="coin-symbol">{{ coin.symbol?.toUpperCase() }}</span>
        </div>
        <div class="coin-sub-info">
          <span class="coin-market-cap">
            MCap: {{ formatNumber(coin.market_cap) }}
          </span>
          <span class="coin-volume">
            Vol 24h: {{ formatNumber(coin.total_volume) }}
          </span>
        </div>
      </div>
    </div>

    <div class="coin-stats">
      <span class="coin-price">
        {{ formatPrice(coin.current_price) }}
      </span>
      <span
        class="coin-change"
        :class="{
          positive: coin.price_change_percentage_24h > 0,
          negative: coin.price_change_percentage_24h < 0
        }"
      >
        {{ formatChange(coin.price_change_percentage_24h) }}
      </span>
    </div>
  </li>
</template>

<script>
export default {
  name: 'MarketListItem',
  props: {
    coin: {
      type: Object,
      required: true
    }
  },
  emits: ['select'],
  setup() {
    const formatPrice = (value) => {
      if (value == null) return '-'
      if (value >= 1000) {
        return '$' + value.toLocaleString('en-US', { maximumFractionDigits: 2 })
      }
      if (value >= 1) {
        return '$' + value.toFixed(2)
      }
      if (value >= 0.01) {
        return '$' + value.toFixed(4)
      }
      return '$' + value.toFixed(6)
    }

    const formatNumber = (value) => {
      if (value == null) return '-'
      if (value >= 1_000_000_000) {
        return (value / 1_000_000_000).toFixed(1) + 'B'
      }
      if (value >= 1_000_000) {
        return (value / 1_000_000).toFixed(1) + 'M'
      }
      if (value >= 1_000) {
        return (value / 1_000).toFixed(1) + 'K'
      }
      return value.toLocaleString('en-US')
    }

    const formatChange = (value) => {
      if (value == null) return '-'
      const sign = value > 0 ? '+' : ''
      return `${sign}${value.toFixed(2)}%`
    }

    return {
      formatPrice,
      formatNumber,
      formatChange
    }
  }
}
</script>

<style scoped>
.market-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md);
  border-radius: var(--radius-lg);
  background: var(--color-bg-secondary);
  cursor: pointer;
  transition: background 0.15s ease, transform 0.05s ease;
}

.market-item:active {
  transform: scale(0.99);
}

.coin-main {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.coin-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  overflow: hidden;
  background: var(--color-bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.coin-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.coin-icon-placeholder {
  font-size: var(--font-size-xs);
  font-weight: 600;
  color: var(--color-text-primary);
}

.coin-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.coin-name-row {
  display: flex;
  align-items: baseline;
  gap: var(--spacing-xs);
}

.coin-name {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
}

.coin-symbol {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.coin-sub-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.coin-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.coin-price {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
}

.coin-change {
  font-size: var(--font-size-xs);
}

.coin-change.positive {
  color: #22c55e;
}

.coin-change.negative {
  color: #ef4444;
}
</style>









